'use client'
const onrampConfigurationToOnrampOption = (provider, onClick) => {
    var _a, _b, _c;
    return ({
        displayName: (_b = (_a = provider.name) !== null && _a !== void 0 ? _a : provider.provider) !== null && _b !== void 0 ? _b : '',
        iconUrl: (_c = provider.iconUrl) !== null && _c !== void 0 ? _c : '',
        id: String(provider.provider),
        iframeUrl: provider.url,
        onClick: (_params) => onClick({
            onrampProvider: provider.provider,
        }),
    });
};

export { onrampConfigurationToOnrampOption };
